import { render, staticRenderFns } from "./SimpleTrunkAnalysis3-2.vue?vue&type=template&id=60d90cdd&scoped=true"
import script from "./SimpleTrunkAnalysis3-2.vue?vue&type=script&lang=ts"
export * from "./SimpleTrunkAnalysis3-2.vue?vue&type=script&lang=ts"
import style0 from "./SimpleTrunkAnalysis3-2.vue?vue&type=style&index=0&id=60d90cdd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d90cdd",
  null
  
)

export default component.exports